<div
  class="fixed top-0 z-50 transition-all duration-300"
  [ngClass]="fullWidth ? 'left-0 w-full' : 'ml-50 w-[84%]'"
  [class.scrolled]="isScrolled"
>
  <div
    class="py-2 px-4 flex items-center justify-between
           backdrop-blur-xl border border-white/30"
  >
    <!-- LEFT: Logo (only on landing page) -->
    <div *ngIf="fullWidth" class="flex items-center gap-3">
      <img src="assets/landing/logo.svg" alt="App Logo" class="h-7 w-50" />
    </div>

    <!-- LEFT: Go Back Section (when sidebar exists) -->
    <div
      *ngIf="!fullWidth"
      class="flex gap-3 cursor-pointer hidden md:flex lg:flex" 
      (click)="goBack()"
    >
      <mat-icon class="text-black text-2xl flex-shrink-0">arrow_back</mat-icon>
      <div class="flex flex-col leading-tight">
        <span class="text-md font-normal text-black uppercase">
          {{ secondLastRoute }}
        </span>
        <span class="text-sm font-normal uppercase text-gray-500">
          {{ currentPage }}
        </span>
      </div>
    </div>
    <!-- RIGHT: Profile Section -->
    <div class="flex items-center gap-6">
      <ng-container *ngIf="userProfile$ | async as userProfile">
        <div
          [matMenuTriggerFor]="menuProfile"
          class="flex items-center gap-3 cursor-pointer"
        >
          <!-- Avatar -->
          <div
            class="w-12 h-12 bg-gray-100 border border-white rounded-full shadow-md flex items-center justify-center"
          >
            <img
              [src]="
                userProfile.photo
                  ? profilePhotoRoute(userProfile.photo)
                  : 'assets/images/avatar.svg'
              "
              alt="Profile Image"
              class="w-10 h-10 rounded-full"
            />
          </div>

          <!-- Name + Email -->
       <div class="flex flex-col"
     [ngClass]="isLanding ? 'text-white' : 'text-black'">
  <span class="font-bold text-sm">
    {{ userProfile.firstName }} {{ userProfile.lastName }}
  </span>
  <span class="text-xs opacity-80"
        [ngClass]="isLanding ? 'text-gray-200' : 'text-gray-500'">
    {{ userProfile.email }}
  </span>
</div>


          <!-- Arrow -->
<mat-icon [style.color]="isLanding ? 'white' : 'black'">
  arrow_drop_down
</mat-icon>
        </div>
      </ng-container>

      <!-- Profile Menu -->
      <mat-menu #menuProfile="matMenu">
        <div class="flex flex-col">
          @for (profMenu of profileMenu; track profMenu) {
          <div
            (click)="profileAction(profMenu)"
            class="px-4 py-3 bg-white flex items-center gap-3 border-b hover:bg-gray-100 cursor-pointer"
          >
            <mat-icon>{{ profMenu?.icon }}</mat-icon>
            <span class="font-medium">{{ profMenu?.name | concat | translate }}</span>
          </div>
          }
        </div>
      </mat-menu>
    </div>
  </div>
</div>
